import { Link, useLocation } from "react-router-dom";
import { Nav, Footer, usePageSeo } from "../layout/shared";

export default function NotFound() {
  const location = useLocation();
  usePageSeo({ title: "Page not found | 3 Counties Recycling", description: "Find recycling services or request a quote from 3 Counties Recycling.", path: location.pathname, noindex: true });
  return (
    <main data-testid="not-found-root" className="bg-white text-[#024120] min-h-screen">
      <Nav />
      <section className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
        <p data-testid="not-found-code" className="font-mono text-sm">404</p>
        <h1 data-testid="not-found-heading" className="font-display font-black text-4xl sm:text-5xl lg:text-6xl mt-4">Page not found.</h1>
        <p data-testid="not-found-message" className="max-w-xl mt-6 text-[#4A4A4A] leading-relaxed">This address may have changed. You can browse our services or get in touch about your material or project.</p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4">
          <Link data-testid="not-found-home-link" to="/" className="bg-[#024120] hover:bg-[#012b14] text-white font-bold px-7 py-4 text-center transition-colors">Back to home</Link>
          <Link data-testid="not-found-quote-link" to="/get-a-quote" className="bg-[#FF6600] hover:bg-[#E55A00] font-bold px-7 py-4 text-center transition-colors">Get a quote</Link>
        </div>
      </section>
      <Footer />
    </main>
  );
}